import { TooltipContainer } from "@outplayed/tooltips";
import React from "react";

const StatToggle = (props) => {
  const { isMobile, onClick, value } = props;

  return (
    <TooltipContainer tooltipInfo={"Toggle HPS/DPS"} disableTooltip={isMobile}>
      <div className="stat-toggle-container" onClick={() => onClick(value)}>
        {value.toUpperCase()}
      </div>
    </TooltipContainer>
  );
};

export default StatToggle;
